import { connect } from 'react-redux'
import { CourseType } from 'common-proptypes'
import CourseListRenderer from './CourseListRenderer.jsx'

const mapStateToProps = state => {
  const allCourses = state.courses.get('allCourses')
  const courses = allCourses ? allCourses.toList().toJS() : []
  return {
    loading: state.courses.get('pending'),
    errors: state.courses.get('errors').toList().toArray(),
    courses,
  }
}
export default connect(mapStateToProps)(class CourseList extends React.PureComponent {
  static propTypes = {
    courses: PropTypes.arrayOf(CourseType),
  }

  render() {
    const {
      courses,
    } = this.props
    if(!courses) {
      return (
        <strong>There are no curricula at this time.</strong>
      )
    }
    return (
      <CourseListRenderer courses={courses} />
    )
  }
})
